<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
]);

const emits = defineEmits([
    "update:alteraJustificativaDeReprovacao"
]);

//==================================================================//
//=========== Altera Justificativa de Reprovação ===================//
//==================================================================//

const alteraJustificativaDeReprovacao = (update = "") =>{

    emits('update:alteraJustificativaDeReprovacao',update);

}

//==================================================================//
//========== Ao Alterar Justificativa de Reprovação ================//
//==================================================================//

const aoAlterarJusiticativaDeReprovacao = (justificativaDeReprovacao = "") =>{

    alteraJustificativaDeReprovacao(justificativaDeReprovacao || "")

}

</script>

<template>

  <v-card class="c-justificativa">

        <v-card-title class="c-justificativa__titulo">
        
            <h3>Justificativa de Reprovação</h3>

        </v-card-title>

        <div class="c-justificativa__conteudo">

            <v-textarea
                :value="props?.dado?.justificativaDeReprovacao"
                class="c-campo"
                label="Observação"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                :disabled="props?.controlesDesativados"
                @input="aoAlterarJusiticativaDeReprovacao"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>

</style>